<template>
	<main>
		<section class="vx-row justify-center lg:mt-24">
			<div class="vx-col w-full md:w-2/3 lg:w-2/3">
				<div class="flex items-center mb-4" @click="$router.push(`/news`)" style="cursor: pointer;">
					<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
					<strong>Kembali</strong>
				</div>

				<vs-card class="p-6">
					<h3 class="text-primary mb-4">
						<strong>{{ news.name }}</strong>
					</h3>
					<p class="text-secondary mb-8">
						<strong>Dibuat pada {{ showDate(news) }}</strong>
					</p>
					<p>
						{{news.berita}}
					</p>
				</vs-card>
			</div>
		</section>
	</main>	
</template>
<script>
export default {
  computed: {
    news () {
      return this.$store.getters['news/detail'](this.$route.params.id)
    }
  },
  methods: {
    showDate (news) {
      const arrNews = news.updated_at.split('.'),
        dates = arrNews[0].split('T')

      return dates.join(', ')
    }
  }
}
</script>